import React from "react";
import { connect } from "react-redux";
import { UserManagementContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { RENDER_ADMIN_STATUS } from "utils/functions/admin";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { MdAdd } from "react-icons/md";
import momentTZ from "moment-timezone";
import queryString from "query-string";
import { RENDER_CHARACTER_REPLACE_BY_PERMISSION } from "utils/functions/string";
import { Buttons, Inputs, Displays, Tables } from "components";
import { PARSE_LIST_QUERY } from "utils/functions/listQuery";

class UserManagementContainer extends React.Component {
  state = {
    isLoading: true,
    pagination: null,
    perPage: 10,
  };

  componentDidMount() {
    const { perPage } = this.state;
    scrollToTopPageFN();
    const query = this.props.router.location.search || `?limit=${perPage}`;
    this.setState(PARSE_LIST_QUERY(this.props.router.location.search, perPage));
    this.fetchData(query);
  }

  fetchData = async (stringQuery) => {
    let resArr = await Promise.all([
      this.fetchAdminData(stringQuery),
      portalService.GET_BUSINESS_UNIT_LIST(),
    ]);
    if (resArr) {
      let renderBusinessObject = {};
      resArr[1].data.docs.forEach((e) => {
        renderBusinessObject[e._id] = e;
      });
      this.setState({
        data: resArr[0].docs,
        dataBusiness: renderBusinessObject,
        isLoading: false,
        pagination: {
          last_page: resArr[0].totalPages,
          current_page: resArr[0].page,
          total: resArr[0].totalDocs,
          per_page: resArr[0].limit,
        },
      });
    }
  };

  fetchAdminData = async (stringQuery, isSet) => {
    let res = await portalService.GET_ADMIN_LIST(stringQuery);
    if (res && res.status === 200) {
      if (isSet) {
        this.setState({
          data: res.data.docs,
          pagination: {
            last_page: res.data.totalPages,
            current_page: res.data.page,
            total: res.data.totalDocs,
            per_page: res.data.limit,
          },
          isLoading: false,
        });
      } else {
        return res.data;
      }
    }
  };

  handleFilterKeyword = (e) => {
    const { perPage } = this.state;
    this.setState({
      filterQuery: e,
    });
    this.handleJoinQuery(e, perPage, 1);
  };

  handleClickCreate = (e) => {
    this.props.router.navigate(`${ROUTE_PATH.USER_MANAGEMENT}/${e}`);
  };

  handlePageClick = (e) => {
    const { filterQuery, perPage } = this.state;
    this.handleJoinQuery(filterQuery, perPage, e.selected + 1);
  };

  handlePerPageChange = (perPage) => {
    const { filterQuery } = this.state;
    this.setState({ perPage });
    this.handleJoinQuery(filterQuery, perPage, 1);
  };

  handleJoinQuery = (query, per_page, page) => {
    let joinQuery = query
      ? `${query}&limit=${per_page}&page=${page}`
      : `?limit=${per_page}&page=${page}`;
    this.setState({
      isLoading: true,
    });
    this.props.router.navigate(`${ROUTE_PATH.USER_MANAGEMENT}${joinQuery}`);
    this.fetchData(joinQuery);
  };

  render() {
    const { authenRedux, router } = this.props;
    const { isLoading, pagination, data } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "user_management");
    return (
      <UserManagementContainerStyled>
        {permission && permission.is_create && (
          <div className="btn_create">
            <div className="w120">
              <Buttons.BgIconPrefix
                label="New"
                icon={<MdAdd size={18} />}
                onClick={() => this.handleClickCreate("create")}
              />
            </div>
          </div>
        )}
        <Inputs.InputFilter
          theme_standard_input_filter
          dataFilter={dataFilter(router.location?.search)}
          btnLabel="ค้นหา"
          onQueryFilter={this.handleFilterKeyword}
        />
        {isLoading ? (
          <Displays.Loading theme_standard_loading heightLayout="324px" />
        ) : (
          <>
            <div className="body_table">
              <Tables.Standard
                columns={columns({
                  permission: permission,
                  handleClickDetail: this.handleClickCreate,
                })}
                data={data}
                showPagination
                pagination={pagination}
                handlePageClick={this.handlePageClick}
                onChangePerPage={this.handlePerPageChange}
              />
            </div>
          </>
        )}
      </UserManagementContainerStyled>
    );
  }
}

const dataFilter = (query) => {
  let initialValues = queryString.parse(query);
  return [
    {
      accessor: "username",
      length: "311px",
      filter: {
        fieldQuery: "username",
        defaultValue: initialValues["username"],
        type: "text",
        label: "Username",
        placeholder: "Username",
      },
    },
    {
      accessor: "email",
      length: "311px",
      filter: {
        fieldQuery: "email",
        defaultValue: initialValues["email"],
        type: "text",
        label: "Email",
        placeholder: "Email",
      },
    },
  ];
};

const columns = ({ permission, handleClickDetail }) => [
  {
    Header: <div style={{ textAlign: "left" }}>Create Date</div>,
    accessor: "created_at",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {momentTZ(props.value).tz("Asia/Bangkok").format("DD/MM/YYYY HH:mm")}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Username</div>,
    accessor: "username",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RENDER_CHARACTER_REPLACE_BY_PERMISSION({
          ...permission,
          inputString: props.value,
        })}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Email</div>,
    accessor: "email",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RENDER_CHARACTER_REPLACE_BY_PERMISSION({
          ...permission,
          inputString: props.value,
        })}
      </div>
    ),
  },
  {
    Header: <div style={{ textAlign: "left" }}>Status</div>,
    accessor: "status",
    Cell: (props) => (
      <div onClick={() => handleClickDetail(props.row.original._id)}>
        {RENDER_ADMIN_STATUS(props.value).label}
      </div>
    ),
  },
];

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserManagementContainer));
